<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/extendCommonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "parkuuids": [
                "ac5fe049-c351-40ec-9858-384e21138dde"
              ],
              "startday": "2023-06-21",
              "endday": "2023-06-27"
            },
            responseCode: {

            },
            infoData: {
                explain: "通过此接口 获取当天与昨天的比较",
                t_url: this.commonUrls.test+"extend/getDayorLastIncome",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkuuids', info2: '是', info3: 'JSONArray', info4: '车场UUID列表' },
                        { info1: 'startday', info2: '是', info3: 'String', info4: '开始时间 yyyy-MM-dd' },
                        { info1: 'lastday', info2: '是', info3: 'String', info4: '结束时间 yyyy-MM-dd' },
                        ]
                }],
                R_params: [{
                  titleName: null,
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'dayTradeList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                  ]
                },{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'Time', info2: '否', info3: 'String', info4: '统计开始时间' },
                        { info1: 'lastTime', info2: '否', info3: 'String', info4: '统计结束时间' },
                        { info1: 'income', info2: '否', info3: 'String', info4: '开始的一天的收入' },
                      { info1: 'lastincome', info2: '否', info3: 'String', info4: '结束的一天的收入' },
                      { info1: 'rate', info2: '否', info3: 'String', info4: '增长率' },
                      { info1: 'timeDate', info2: '否', info3: 'String', info4: '统计日期时间戳'},
                      { info1: 'lastTimeDate', info2: '否', info3: 'String', info4: '统计上一天时间戳' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/other/getDayorLastIncome.vue